import { create } from "zustand";

const useMyStore = create((set) => ({
  userLoggedIn: false,
  user: undefined,
  setUserLoggedIn: (value) => set((state) => ({ ...state, userLoggedIn: value })),
  setUser: (user) => set((state) => ({ ...state, user })),
}));

export default useMyStore;
